import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getTagClass, getTagLabel } from "./utils";
export function ChangeItem({ change }) {
    return /*#__PURE__*/ _jsxs("li", {
        className: "text-sm text-gray-700 leading-relaxed relative",
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "absolute -left-6 text-gray-400",
                children: "•"
            }),
            change.tags && change.tags.length > 0 && /*#__PURE__*/ _jsx("span", {
                className: "mr-2",
                children: change.tags.map((tag, tagIdx)=>/*#__PURE__*/ _jsx("span", {
                        className: `inline-block text-xs font-semibold px-2 py-0.5 rounded mr-1 ${getTagClass(tag)}`,
                        children: getTagLabel(tag)
                    }, tagIdx))
            }),
            /*#__PURE__*/ _jsx("span", {
                children: change.description.split(/(`[^`]+`)/).map((part, i)=>{
                    if (part.startsWith('`') && part.endsWith('`')) {
                        return /*#__PURE__*/ _jsx("code", {
                            className: "font-mono text-xs bg-navy-5 px-1.5 py-0.5 rounded text-primary",
                            children: part.slice(1, -1)
                        }, i);
                    }
                    return /*#__PURE__*/ _jsx("span", {
                        children: part
                    }, i);
                })
            })
        ]
    });
}
